import React, { FC, FormEvent, useState } from 'react';
import { FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import SearchIcon from '@mui/icons-material/Search';
import { SearchType } from './SearchType';

type Props = {
  handleSubmit: (searchType: SearchType, searchValue: string) => void;
  isLoading: boolean;
};

const SearchBar: FC<Props> = ({ handleSubmit, isLoading }) => {
  const [searchType, setSearchType] = useState<SearchType>('name');
  const handleSearchByChange = (event: SelectChangeEvent) => setSearchType(event.target.value as SearchType);

  const [searchValue, setSearchValue] = useState('');
  const handleSearchValueChange = (event: React.ChangeEvent<HTMLInputElement>) => setSearchValue(event.target.value.trim());

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleSubmit(searchType, searchValue);
  };

  return (
    <form onSubmit={onSubmit} data-testid="customer-search-form">
      <Grid container marginBottom="medium" alignItems="flex-end" spacing={1}>
        <Grid item marginRight="small">
          <FormControl>
            <InputLabel id="search-by-label">Search by</InputLabel>
            <Select
              label="Search by"
              labelId="search-by-label"
              onChange={handleSearchByChange}
              size="small"
              value={searchType}
              data-testid="search-by"
            >
              <MenuItem value="name">Any</MenuItem>
              <MenuItem value="phone">Phone (Exact)</MenuItem>
              <MenuItem value="email">Email (Exact)</MenuItem>
              <MenuItem value="company">Company (Exact)</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item flexGrow={1}>
          <TextField
            style={{ width: '100%' }}
            id="search-input"
            placeholder="Search by name, email, phone, or company"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            variant="outlined"
            size="small"
            onChange={handleSearchValueChange}
          />
        </Grid>

        <Grid item>
          <LoadingButton loading={isLoading} variant="contained" sx={{ height: 40 }} type="submit" data-testid="search-button">
            Search
          </LoadingButton>
        </Grid>
      </Grid>
    </form>
  );
};

export default SearchBar;
